module.exports = {
    releaseDate: '2020-04-15',
    build: '1.0.0-dev'
};
